/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const formatListNumbered = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M11.1 15.8H20v-1.5h-8.9v1.5zM4 7.2v1.5h16V7.2H4zm.2 6.8l.8-.3V17h1v-4.7l-2.2.7.4 1z" />
	</SVG>
);

export default formatListNumbered;
